import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		FORM_TYPE: {
			CREATE: 'Create',
			UPDATE: 'Update',
			READ: 'Read',
		},
		refreshTokenIntervalId: 0,
		userProfile: {},
		permissionList: [],
		tourList: [
			{
				id: 1,
				name_uz: "O'zbekiston: klassik standart shaxsiy tur (6 kun)",
				name_ru: "Узбекистан: классический стандартный индивидуальный тур (6 дней)",
				name_en: "Uzbekistan Classic — Standard Private Tour (6 days)",
				name_jp: "ウズベキスタン クラシック・スタンダード プライベート6日間",
				destination_uz: "O'zbekiston",
				destination_ru: "Узбекистан",
				destination_en: "Uzbekistan",
				destination_jp: "ウズベキスタン",
				duration_uz: "6 kun",
				duration_ru: "6 дней",
				duration_en: "6 days",
				duration_jp: "6日間",
				num_of_person_uz: "1–5 kishi",
				num_of_person_ru: "1–5 человек",
				num_of_person_en: "1–5 people",
				num_of_person_jp: "1〜5名",
				star: "4.9",
				price_us: "From $1,090/person (5 travelers)",
				price: 68125000,
				image: 'image/uzbekistan-tour-standard.jpg',
				pricing_kind: 'tiered',
				tiered_usd_per_person: [2550, 1500, 1350, 1170, 1090],
				description_uz: "Toshkent, Samarqand va Buxoro bo'ylab klassik yo'l: Registon, qadimiy mahalla va bozorlar, 3–4 yulduzli mehmonxonalar, shaharlararo transferlar va mahalliy gidlar. Kichik shaxsiy guruhlar uchun mos narxlash.",
				description_ru: "Классический маршрут Ташкент — Самарканд — Бухара: Регистан, старые кварталы и базары, отели 3–4*, трансферы между городами и местные гиды. Цены для небольших частных групп.",
				description_en: "A private classic circuit across Tashkent, Samarkand, and Bukhara: Registan, old quarters and bazaars, comfortable 3–4* hotels, intercity transfers, and local guides. Tiered pricing for private groups of one to five.",
				description_jp: "タシケント・サマルカンド・ブハラを巡る定番のプライベート周遊：レギスタン広場、旧市街とバザール、3〜4つ星ホテル、都市間送迎、現地ガイド付き。1〜5名向けの段階価格です。",
				highlights_uz: [
					"Toshkent — zamonaviy markaz va tarixiy mahalla",
					"Samarqand — Registon, Shohi Zinda, Gur-Amir",
					"Buxoro — Lyabi-Hauz, Qal'ai Ark, Po-i Kalyan",
					"Transferlar va nonushta bilan mehmonxona",
				],
				highlights_ru: [
					"Ташкент — современный центр и старый город",
					"Самарканд — Регистан, Шахи-Зинда, Гур-Эмир",
					"Бухара — Ляби-Хауз, Арк, Пои-Калян",
					"Трансферы и отели с завтраком",
				],
				highlights_en: [
					"Tashkent — modern centre and historic quarters",
					"Samarkand — Registan, Shah-i-Zinda, Gur-e Amir",
					"Bukhara — Lyabi-Hauz, Ark fortress, Po-i-Kalyan",
					"Intercity transfers and hotels with breakfast",
				],
				highlights_jp: [
					"タシケント — 近代的中心部と旧市街",
					"サマルカンド — レギスタン、シャーヒ・ズィンダ、グル・アミール廟",
					"ブハラ — リャビハウズ、アルク要塞、ポイ・カリャン",
					"都市間送迎・朝食付きホテル",
				],
				itinerary_uz: [
					{ title: "1–2 kun: Toshkent", body: "Uchrashuv, shahar bo'ylab sayohat: Amir Temur maydoni, Chorsu bozori, metro tajribasi, san'at muzeylari." },
					{ title: "3–4 kun: Samarqand", body: "Poytaxtdan poyezd yoki avto. Registon, Bibixonim, Siyob bozori, observatoriya va Shahi Zinda." },
					{ title: "5–6 kun: Buxoro va chiqish", body: "UNESCO markazi: Lyabi-Hauz, madrasalar, Kalyan minora va masjid, Ark. Erkin vaqt, aeroportga transfer." },
				],
				itinerary_ru: [
					{ title: "Дни 1–2: Ташкент", body: "Встреча, обзорная экскурсия: площадь Амира Тимура, базар Чорсу, метро, музеи." },
					{ title: "Дни 3–4: Самарканд", body: "Переезд из столицы. Регистан, Биби-Ханым, базар Сиаб, обсерватория Улугбека, Шахи-Зинда." },
					{ title: "Дни 5–6: Бухара и отъезд", body: "Центр ЮНЕСКО: Ляби-Хауз, медресе, Пои-Калян, Арк. Свободное время, трансфер в аэропорт." },
				],
				itinerary_en: [
					{ title: "Days 1–2: Tashkent", body: "Meet-and-greet, city highlights: Amir Timur square, Chorsu bazaar, metro ride, applied arts and city centre." },
					{ title: "Days 3–4: Samarkand", body: "Travel from the capital. Registan, Bibi-Khanym, Siab bazaar, Ulugbek observatory, Shah-i-Zinda." },
					{ title: "Days 5–6: Bukhara & departure", body: "UNESCO core: Lyabi-Hauz, madrasas, Kalyan minaret & mosque, Ark. Free time, airport transfer." },
				],
				itinerary_jp: [
					{ title: "1〜2日目：タシケント", body: "空港ミート、市内観光：アミール・ティムール広場、チョルスバザール、地下鉄、工芸博物館など。" },
					{ title: "3〜4日目：サマルカンド", body: "移動後、レギスタン、ビビハニム・モスク、シアブバザール、ウルグベク天文台、シャーヒ・ズィンダ。" },
					{ title: "5〜6日目：ブハラ・出発", body: "世界遺産の旧市街と名所を観光後、自由行動、空港へ送迎。" },
				],
			},
			{
				id: 2,
				name_uz: "O'zbekiston: komfort shaxsiy tur (6 kun)",
				name_ru: "Узбекистан: комфортный индивидуальный тур (6 дней)",
				name_en: "Uzbekistan — Comfort Private Tour (6 days)",
				name_jp: "ウズベキスタン コンフォート プライベート6日間",
				destination_uz: "O'zbekiston",
				destination_ru: "Узбекистан",
				destination_en: "Uzbekistan",
				destination_jp: "ウズベキスタン",
				duration_uz: "6 kun",
				duration_ru: "6 дней",
				duration_en: "6 days",
				duration_jp: "6日間",
				num_of_person_uz: "1–5 kishi",
				num_of_person_ru: "1–5 человек",
				num_of_person_en: "1–5 people",
				num_of_person_jp: "1〜5名",
				star: "5.0",
				price_us: "From $1,300/person (5 travelers)",
				price: 81250000,
				image: 'image/uzbekistan-tour-comfort.jpg',
				pricing_kind: 'tiered',
				tiered_usd_per_person: [3400, 2080, 1640, 1480, 1300],
				description_uz: "Xuddi shu klassik marshrut, lekin yuqori darajadagi mehmonxonalar, qulay transport va vaqtni moslashuvchan rejalashtirish — komfortni ustuvor qiladi.",
				description_ru: "Тот же классический маршрут, но с отелями повышенной категории, удобным транспортом и гибким ритмом дня — для максимального комфорта.",
				description_en: "The same classic Tashkent–Samarkand–Bukhara route with upgraded hotels, comfortable private transport, and a relaxed pace—designed for travellers who want extra comfort.",
				description_jp: "タシケント・サマルカンド・ブハラの定番ルートを、上質なホテルと快適な専用送迎、ゆとりある日程で。快適さを重視する方向けです。",
				highlights_uz: [
					"4–5 yulduzli yoki boutique mehmonxonalar",
					"Shaharlararo shaxsiy transport",
					"Tajribali gidlar va VIP kutish",
					"Nonushta va tanlangan tadbirlar",
				],
				highlights_ru: [
					"Отели 4–5* и бутик-отели",
					"Индивидуальный транспорт между городами",
					"Опытные гиды и встреча в аэропорту",
					"Завтраки и отобранные впечатления",
				],
				highlights_en: [
					"4–5* and boutique hotels",
					"Private vehicle between cities",
					"Experienced guides and meet & greet",
					"Daily breakfast and curated experiences",
				],
				highlights_jp: [
					"4〜5つ星およびブティックホテル",
					"都市間は専用車で移動",
					"経験豊富なガイドとお出迎え",
					"毎朝食と厳選された体験",
				],
				itinerary_uz: [
					{ title: "1–2 kun: Toshkent (komfort)", body: "Premium mehmonxona, shaxsiy avto bilan kengaytirilgan shahar turi." },
					{ title: "3–4 kun: Samarqand", body: "Eng yaxshi joylashuvdagi mehmonxona; Registon va atrof-muhitga chuqurroq vaqt." },
					{ title: "5–6 kun: Buxoro va chiqish", body: "Boutique mehmonxona, tarixiy markazda sayohat. Imkoniyat bo'lsa late check-out, VIP aeroport transferi." },
				],
				itinerary_ru: [
					{ title: "Дни 1–2: Ташкент (комфорт)", body: "Отель премиум-класса, расширенная обзорная экскурсия на частном авто." },
					{ title: "Дни 3–4: Самарканд", body: "Отель в лучшем расположении; больше времени у Регистана и окрестностей." },
					{ title: "Дни 5–6: Бухара и отъезд", body: "Бутик-отель, прогулки по центру. Поздний выезд при возможности, трансфер в аэропорт." },
				],
				itinerary_en: [
					{ title: "Days 1–2: Tashkent (comfort)", body: "Premium hotel base, extended city touring with private vehicle." },
					{ title: "Days 3–4: Samarkand", body: "Top-located hotel; deeper time at Registan and surrounding monuments." },
					{ title: "Days 5–6: Bukhara & departure", body: "Boutique stay in the old city, walking routes. Late check-out where possible, private airport transfer." },
				],
				itinerary_jp: [
					{ title: "1〜2日目：タシケント（コンフォート）", body: "高級ホテル滞在、専用車での充実した市内観光。" },
					{ title: "3〜4日目：サマルカンド", body: "立地の良いホテルに宿泊、レギスタン周辺をゆっくり満喫。" },
					{ title: "5〜6日目：ブハラ・出発", body: "旧市街のブティックホテルで街歩き。可能ならレイトチェックアウトの後、専用車で空港へ。" },
				],
			},
			{
				id: 3,
				name_uz: "O'zbekistonga marhamat — 6 kunlik madaniy tur",
				name_ru: "Добро пожаловать в Узбекистан — 6 дней культурного тура",
				name_en: "Welcome to Uzbekistan — 6-Day Cultural Tour",
				name_jp: "ウェルカム・トゥ・ウズベキスタン 文化6日間",
				destination_uz: "O'zbekiston (Toshkent, Buxoro, Samarqand)",
				destination_ru: "Узбекистан (Ташкент, Бухара, Самарканд)",
				destination_en: "Uzbekistan (Tashkent, Bukhara, Samarkand)",
				destination_jp: "ウズベキスタン（タシケント・ブハラ・サマルカンド）",
				duration_uz: "6 kun",
				duration_ru: "6 дней",
				duration_en: "6 days",
				duration_jp: "6日間",
				num_of_person_uz: "1–5 kishi",
				num_of_person_ru: "1–5 человек",
				num_of_person_en: "1–5 people",
				num_of_person_jp: "1〜5名",
				star: "4.9",
				price_us: "From $1,090/person (5 travelers)",
				price: 68125000,
				image: 'image/uzbekistan-welcome-6days.jpg',
				pricing_kind: 'tiered',
				tiered_usd_per_person: [2690, 1540, 1350, 1190, 1090],
				description_uz: "Qisqa lekin to'liq: poytaxtdan start, tezyurar poyezd bilan Buxoro, keyin Samarqandning eng mashhur obidalari va qog'oz san'ati, so'ng Toshkentga qaytish. Shaxsiy tur, yil bo'yi mavjud.",
				description_ru: "Короткий, но насыщенный маршрут: столица, скоростной поезд в Бухару, затем Самарканд с главными памятниками и деревней Конигиль, возврат в Ташкент. Индивидуальный тур, круглый год.",
				description_en: "A compact cultural loop: start in Tashkent, take the high-speed train to Bukhara, explore Samarkand’s great sites plus Konigil village, then return to Tashkent by train. Private tour, available year-round.",
				description_jp: "タシケント発、高速列車でブハラへ。サマルカンドの名所と伝統紙の里コニギル村を巡り、再び列車でタシケントへ。プライベートツアー、通年催行。",
				highlights_uz: [
					"Toshkent: Chorsu, Khast Imam, metro",
					"Afrosiyob poyezdi: Toshkent — Buxoro",
					"Buxoro va Samarqandning UNESCO yadgorliklari",
					"Samarqand — Toshkent yo'lida qog'oz ustaxonasi",
				],
				highlights_ru: [
					"Ташкент: Чорсу, Хаст Имам, метро",
					"Поезд Афросиёб: Ташкент — Бухара",
					"Объекты ЮНЕСКО в Бухаре и Самарканде",
					"Мастерская бумаги в Конигиле",
				],
				highlights_en: [
					"Tashkent: Chorsu, Khast Imam, metro",
					"Afrosiyob train: Tashkent–Bukhara",
					"UNESCO highlights in Bukhara & Samarkand",
					"Samarkand paper workshop in Konigil",
				],
				highlights_jp: [
					"タシケント：チョルス、ハスト・イマム、地下鉄",
					"アフロシャーブ列車：タシケント〜ブハラ",
					"ブハラ・サマルカンドの世界遺産",
					"コニギル村の伝統紙づくり体験",
				],
				itinerary_uz: [
					{ title: "1-kun: Toshkent — kelish", body: "Mehmonxonada joylashish. Shahar bo'ylab sayohat: Jasorat yodgorligi, eski shahar, Khast Imam majmuasi, Chorsu bozori, metro, Amaliy san'at muzeyi, Amir Temur maydoni." },
					{ title: "2-kun: Toshkent — Buxoro", body: "Erta Afrosiyob poyezdi. Buxoroda gid bilan sayohat: Lyabi-Hauz, savdo gumbazlari, Kalyan minora va masjid, Miri-Arab madrasasi, Ark qal'asi." },
					{ title: "3-kun: Buxoro — Samarqand", body: "Sitorai Mohi-Xosa, Naqshband maqbarasi, keyin Samarqandga yo'l (taxminan 4 soat)." },
					{ title: "4-kun: Samarqand", body: "Registon, Bibi-Xonim, Siab bozori, Ulugbek observatoriyasi, Shahi Zinda, Gur-Amir." },
					{ title: "5-kun: Samarqand — Toshkent", body: "Afrasiab muzeyi, Doniyol paygambar maqbarasi, Konigil qishlog'ida qog'oz ustaxonasi. Kechqurun tezyurar poyezd bilan Toshkentga." },
					{ title: "6-kun: Toshkent — jo'nash", body: "Erta chiqish, erkin vaqt, aeroportga transfer." },
				],
				itinerary_ru: [
					{ title: "День 1: Ташкент — прибытие", body: "Размещение в отеле. Обзорная экскурсия: монумент «Мужество», старый город, комплекс Хаст Имам, базар Чорсу, метро, музей прикладного искусства, площадь Амира Тимура." },
					{ title: "День 2: Ташкент — Бухара", body: "Утром поезд Афросиёб. В Бухаре пешеходная экскурсия: Ляби-Хауз, торговые купола, минарет Калян и мечеть, медресе Мири-Араб, крепость Арк." },
					{ title: "День 3: Бухара — Самарканд", body: "Ситораи Мохи-Хоса, мавзолей Бахаутдина Накшбанда, затем переезд в Самарканд (около 4 часов)." },
					{ title: "День 4: Самарканд", body: "Регистан, мечеть Биби-Ханым, базар Сиаб, обсерватория Улугбека, Шахи-Зинда, мавзолей Гур-Эмир." },
					{ title: "День 5: Самарканд — Ташкент", body: "Музей Афросиаб, мавзолей пророка Даниила, деревня Конигил (изготовление бумаги). Вечером скоростной поезд в Ташкент." },
					{ title: "День 6: Ташкент — отъезд", body: "Выезд из отеля, свободное время, трансфер в аэропорт." },
				],
				itinerary_en: [
					{ title: "Day 1: Tashkent — arrival", body: "Hotel check-in. City tour: Monument of Courage, Old City, Khast Imam ensemble, Chorsu bazaar, metro, Museum of Applied Arts, Amir Timur square." },
					{ title: "Day 2: Tashkent — Bukhara", body: "Morning Afrosiyob train. Walking tour in Bukhara: Lyabi-Hauz, trade domes, Kalyan minaret & mosque, Miri-Arab madrasah, Ark fortress." },
					{ title: "Day 3: Bukhara — Samarkand", body: "Sitorai Mokhi-Khosa, Bakhoutdin Naqshbandi memorial, then drive to Samarkand (~4 hours)." },
					{ title: "Day 4: Samarkand", body: "Registan, Bibi-Khanym mosque, Siab bazaar, Ulugbek observatory, Shah-i-Zinda, Gur-e Amir." },
					{ title: "Day 5: Samarkand — Tashkent", body: "Afrasiab museum, Tomb of Saint Daniel, Konigil village (traditional paper). Evening high-speed train to Tashkent." },
					{ title: "Day 6: Tashkent — departure", body: "Check-out, free time, transfer to Tashkent International Airport." },
				],
				itinerary_jp: [
					{ title: "1日目：タシケント（到着）", body: "ホテルにチェックイン後、市内観光：勇気の記念碑、旧市街、ハスト・イマム、チョルスバザール、地下鉄、工芸博物館、アミール・ティムール広場。" },
					{ title: "2日目：タシケント〜ブハラ", body: "朝、アフロシャーブ列車でブハラへ。リャビハウズ、交易ドーム、カリャン・ミナレット、ミリー・アラブ神学校、アルク要塞などを歩いて観光。" },
					{ title: "3日目：ブハラ〜サマルカンド", body: "シトライ・モヒ・ホサ、ナクシュバンド廟の後、サマルカンドへ車で約4時間。" },
					{ title: "4日目：サマルカンド", body: "レギスタン、ビビハニム・モスク、シアブバザール、ウルグベク天文台、シャーヒ・ズィンダ、グル・アミール廟。" },
					{ title: "5日目：サマルカンド〜タシケント", body: "アフラシアブ博物館、聖ダニエル廟、コニギル村の和紙工房。夕方、高速列車でタシケントへ。" },
					{ title: "6日目：タシケント（出発）", body: "チェックアウト、自由行動の後、空港へ送迎。" },
				],
			},
		]
	},
	getters: {
		tourList: (state) => state.tourList
	},
	mutations: {},
	actions: {},
	modules: {},
});
